import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

// One card to render any content item across the ecosystem.
// Scales cleanly: optional thumbnail, type badge, status chip, meta row.
export default function ContentCard({ item, index = 0, onClick }) {
  const isComingSoon = item.status === "coming-soon";
  const Wrapper = onClick ? "button" : "div";

  return (
    <Reveal delay={(index % 3) * 0.05}>
      <Wrapper
        onClick={onClick ? () => onClick(item) : undefined}
        data-testid={`content-card-${item.id}`}
        className={`group relative w-full text-left border border-white/10 bg-ink-surface overflow-hidden h-full flex flex-col transition-all duration-300 hover:-translate-y-1 hover:border-white/20 ${
          onClick ? "cursor-pointer" : ""
        }`}
      >
        {item.thumbnail && (
          <div className="relative h-44 overflow-hidden">
            <img
              src={item.thumbnail}
              alt=""
              className="w-full h-full object-cover opacity-55 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500"
            />
            {item.type && (
              <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.2em] bg-burnt text-white px-2.5 py-1">
                {item.type}
              </span>
            )}
            {isComingSoon && (
              <span className="absolute top-3 right-3 text-[10px] uppercase tracking-[0.18em] bg-black/70 backdrop-blur text-gold px-2.5 py-1 border border-gold/30">
                Coming Soon
              </span>
            )}
          </div>
        )}

        <div className="p-6 flex flex-col flex-1">
          {!item.thumbnail && item.type && (
            <span className="text-[10px] uppercase tracking-[0.2em] text-gold mb-3">
              {item.type}
            </span>
          )}
          <div className="flex items-center gap-2 text-xs text-zinc-600 mb-2">
            {item.category && <span>{item.category}</span>}
            {item.category && item.date && <span className="text-zinc-700">·</span>}
            {item.date && <span>{item.date}</span>}
          </div>
          <h3 className="font-heading text-lg font-medium text-white group-hover:text-gold transition-colors">
            {item.title}
          </h3>
          {item.excerpt && (
            <p className="mt-2 text-sm text-zinc-500 leading-relaxed line-clamp-3">
              {item.excerpt}
            </p>
          )}

          <div className="mt-5 pt-4 border-t border-white/10 flex items-center justify-between text-xs text-zinc-500 mt-auto">
            <span className="flex items-center gap-2">
              {item.readTime && (
                <>
                  <Clock size={13} className="text-burnt" /> {item.readTime}
                </>
              )}
              {!item.readTime && item.meta && item.meta}
            </span>
            {onClick && (
              <ArrowUpRight
                size={16}
                className="text-zinc-600 group-hover:text-burnt transition-colors"
              />
            )}
          </div>
        </div>
      </Wrapper>
    </Reveal>
  );
}
